import React from 'react';

import { useTimer } from 'react-timer-hook';

import styles from './ResendEmailTimer.module.scss';

const EXPIRY_SECONDS = 59;

const ResendEmailTimer = ({ onExpire }: { onExpire: () => void }) => {
  const expiryTimestamp = new Date();

  expiryTimestamp.setSeconds(expiryTimestamp.getSeconds() + EXPIRY_SECONDS);

  const { seconds } = useTimer({
    expiryTimestamp: expiryTimestamp,
    onExpire: onExpire,
  });

  return (
    <p className={styles.text}>
      You can send another email in <span className={styles.boldText}>{seconds}s</span>
    </p>
  );
};

export default ResendEmailTimer;
